import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import { StickyContainer } from 'react-sticky'
import ResourceSummary from '../../../components/resource-summary'
import EfficiencySummary from '../../../components/efficiency-summary'
import ProjectImplementation from '../../../components/project-implementation-plan'

const ActualEfficiency = class extends React.Component {
  render() {
    const efficiencyResource = get(this.props, 'efficiencyResource')
    const lobs = get(efficiencyResource, 'lobs')
    const is_submited = get(efficiencyResource, 'efficiencyResource.is_submited')
    let efficiencySummary = []
    let addition_projects = []
    let projectAdditionalList = []
    let base_project = []
    let currentMonthSummary = []
    let efficiencyID = ''
    if (is_submited) {
      efficiencySummary = get(efficiencyResource, 'efficiencyResource.efficiency_resource_snapshot.efficiencySummary')
      addition_projects = get(efficiencyResource, 'efficiencyResource.efficiency_resource_snapshot.addition_projects', [])
      projectAdditionalList = get(efficiencyResource, 'efficiencyResource.efficiency_resource_snapshot.projectAdditionalList', [])
      base_project = get(efficiencyResource, 'efficiencyResource.efficiency_resource_snapshot.base_project', [])
      currentMonthSummary = get(efficiencyResource, 'efficiencyResource.efficiency_resource_snapshot.currentMonthSummary', [])
      efficiencyID = get(efficiencyResource, 'efficiency_resource_snapshot._id', [])
    } else {
      efficiencySummary = get(efficiencyResource, 'efficiencySummary')
      addition_projects = get(efficiencyResource, 'efficiencyResource.addition_projects', [])
      projectAdditionalList = get(efficiencyResource, 'projectAdditionalList', [])
      base_project = get(efficiencyResource, 'efficiencyResource.base_project', [])
      currentMonthSummary = get(efficiencyResource, 'currentMonthSummary', [])
      efficiencyID = get(efficiencyResource, 'efficiencyResource._id', [])
    }
    return (
      <Wrapper>
        <StickyContainer className="container relative">
          <div className="gap tall">
            <ResourceSummary
              currentMonthSummary={ currentMonthSummary }
            />
            <EfficiencySummary
              idChart={ 'efficiencyMixedChart' }
              header={ 'Efficiency Summary' }
              widthLeft={ 400 }
              efficiencySummary={ efficiencySummary }
            />
            <ProjectImplementation
              is_submited={ is_submited }
              efficiencyID={ efficiencyID }
              lobs={ lobs }
              efficiencySummary={ efficiencySummary }
              addition_projects={ addition_projects }
              base_project={ base_project }
              projectAdditionalList={ projectAdditionalList }
              editEfficiency={ get(this.props, 'editEfficiency') }
              widthLeft={ 400 }
            />
          </div>
        </StickyContainer>
      </Wrapper>
    )
  }
}

export default ActualEfficiency

const Wrapper = styled.div`
  background-color: #ffffff ;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  .container {
    height: calc(100vh - 240px);
    background: #EEEEEE;
    max-width: 100% ;
  }
  .gap.tall {
    height: 100%;
  }
  .container.relative {
    overflow-y: auto;
    margin: 0px;
    padding: 0px;
  }
`




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-submit/tab-content/actual-efficiency.js